import request from '../request'
export default {
  // 订单查询
  loginHsbcUser: function (param) {
    return request.Post('loginHsbcUser', {}, {
      username: param.userName || '',
      password: param.passwd || '',
      code: param.code || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  loginOperatorUser (param) {
    return request.Post('loginOperatorUser', {}, {
      username: param.userName || '',
      password: param.passwd || '',
      code: param.code || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  createDzUser: function (param) {
    return request.Post('shop/createDzUser', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getDzUser: function (param) {
    return request.Post('shop/getDzUser', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  createGysUser: function (param) {
    return request.Post('shop/createGysUser', {
      supplierName: param.userName,
      orgNo: param.orgNo,
      passwd: param.passwd,
      address: param.address,
      contactTel: param.userTel,
      contactUser: param.contactUser,
      isAgreed: 1
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  createHsbcOperator: function (param) {
    return request.Post('shop/createHsbcOperator', {
      userName: param.userName,
      address: param.address,
      passwd: param.passwd,
      tel: param.userTel
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }
}
